import { render, staticRenderFns } from "./SportGlide.vue?vue&type=template&id=3bf4bd75&"
import script from "./SportGlide.vue?vue&type=script&lang=ts&"
export * from "./SportGlide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports